/*  MUI  */
import { Box } from '@mui/material';

/*  React  */
import React from 'react';

/* Components */
import GoogleAuth from './Components/Containers/GoogleAuth';
import MicrosoftAuth from './Components/Containers/MicrosoftAuth';

export const LoginLegacy = () => (
    <Box data-testid="loginLegacy">
        <Box my="16px" data-trackid="loginMicrosoftAuth">
            <MicrosoftAuth scopeType="login" login />
        </Box>
        <Box my="4px" data-trackid="loginGoogleAuth">
            <GoogleAuth login />
        </Box>
    </Box>
);
